// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"iU-z"};